export default {
  send: 'Envoyer',
  typeMessage: 'Saisir un message...',
};
